import { render, staticRenderFns } from "./WorkingoutGuide.vue?vue&type=template&id=3a415f2a&scoped=true"
import script from "./WorkingoutGuide.vue?vue&type=script&lang=js"
export * from "./WorkingoutGuide.vue?vue&type=script&lang=js"
import style0 from "./WorkingoutGuide.vue?vue&type=style&index=0&id=3a415f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a415f2a",
  null
  
)

export default component.exports